export const farmProduct = [
  {
    id: "MA-482-7319-AGRO",
    name: "2025 Hitachi ZX350LC-7 Excavator",
    stockNumber: "MA-482-7319-AGRO",
    price: "305000",
    description:
      "CAB, A/C, 60″ Pin On Bucket, Aux Hydraulics, 270 Camera View, 599 Hours",
    category: "Used",
    images: [
      "/Equipments/one/1.jpeg",
      "/Equipments/one/2.jpeg",
      "/Equipments/one/3.jpeg",
      "/Equipments/one/4.jpeg",
      "/Equipments/one/5.jpeg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "AGRO-165-4963Y-MA",
    name: "Used 2016 John Deere 5115M Tractor",
    stockNumber: "AGRO-165-4963Y-MA",
    price: "33000",
    description:
      "Used, Cab, A/C, 115 HP, 4 Rear Remotes, Front/Rear 3-Point Hitch, 5300 Hours",
    category: "Used",
    images: [
      "/Equipments/two/1.jpg",
      "/Equipments/two/2.jpg",
      "/Equipments/two/3.jpg",
      "/Equipments/two/4.jpg",
      "/Equipments/two/5.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "MA-771-5093-AGRO",
    name: "Used 2022 REARS KCH818",
    stockNumber: "MA-771-5093-AGRO",
    price: "25999",
    description: "Rotary Cutters & Shredders",
    category: "Used",
    images: [
      "/Equipments/fourteen/1.jpg",
      "/Equipments/fourteen/2.jpg",
      "/Equipments/fourteen/3.jpg",
      "/Equipments/fourteen/4.jpg",
      "/Equipments/fourteen/5.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "AGRO-288-6401Y-MA",
    name: "Used 2024 H & S 2217",
    stockNumber: "AGRO-288-6401Y-MA",
    price: "19500",
    description:
      "New 2024 H&S S2217 Manure Spreader, 175 Bushels, Sides Constructed Of Powder-Coated Steel, Front Splash Guards Are Standard, Greaseable Bearings, 2 Speed Gearbox,",
    category: "New",
    images: [
      "/Equipments/thirteen/1.webp",
      "/Equipments/thirteen/2.webp",
      "/Equipments/thirteen/3.webp",
      "/Equipments/thirteen/4.webp",
      "/Equipments/thirteen/5.webp",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "731-AGRO-MA-5824X",
    name: "Used 2019 JCB 930 Rough-Terrain Forklift",
    stockNumber: "731-AGRO-MA-5824X",
    price: "38500",
    description:
      "ROPS, Lever Controls, Triplex Mast, Diesel, 6000lb Lift Capacity, Side Shift, Fork Positioner, 60 Forks, 2200 Hours",
    category: "Used",
    images: [
      "/Equipments/three/1.jpg",
      "/Equipments/three/2.jpg",
      "/Equipments/three/3.jpg",
      "/Equipments/three/4.jpg",
      "/Equipments/three/5.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "MA-412-8954-AGRO",
    name: "Millcreek | Large Top Dresser ",
    stockNumber: "MA-412-8954-AGRO",
    price: "30100",
    description:
      "Model 4300 Turf Tiger | 7,500 lbs Capacity | Horsepower 35 HP | For Tractor",
    category: "New",
    images: [
      "/Equipments/twelve/1.webp",
      "/Equipments/twelve/2.webp",
      "/Equipments/twelve/3.webp",
      "/Equipments/twelve/4.webp",
      "/Equipments/twelve/5.webp",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "MA-904-1187-AGRO",
    name: "Used 2021 Case SV340B Skid Steer",
    stockNumber: "MA-904-1187-AGRO",
    price: "49500",
    description:
      "Cab, A/C, 90HP, Highflow Hyd, Hyd Coupler, 2 Speed, Emissions Warranty Exp. 9/28/26, 485 Hours",
    category: "Used",
    images: [
      "/Equipments/four/1.jpg",
      "/Equipments/four/2.jpg",
      "/Equipments/four/3.jpg",
      "/Equipments/four/4.jpg",
      "/Equipments/four/5.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "134-AGRO-MA-6882V",
    name: "Used 2020 John Deere MX5",
    stockNumber: "134-AGRO-MA-6882V",
    price: "2999",
    description: "Rotary Cutters & Shredders",
    category: "Used",
    images: ["/Equipments/fifteen/1.jpg", "/Equipments/fifteen/2.jpg"],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "MA-625-1180-AGRO",
    name: "Used 2023 Toyota 50-8FGU25 Pneumatic Forklift",
    stockNumber: "MA-625-1180-AGRO",
    price: "33000",
    description:
      "ROPS, Lever Controls, Quadplex Mast, LPG, 5,000lb Lift Capacity, 2038 Hours",
    category: "Used",
    images: [
      "/Equipments/sixteen/1.jpg",
      "/Equipments/sixteen/2.jpg",
      "/Equipments/sixteen/2.jpg",
      "/Equipments/sixteen/2.jpg",
      "/Equipments/sixteen/2.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "AGRO-773-2048Z-MA",
    name: "Used 2019 New Holland Workmaster 60 Tractor",
    stockNumber: "AGRO-773-2048Z-MA",
    price: "31000",
    description:
      "ROPS, 4×4, Loader, 60 HP, 2 Rear Remotes, 8×8 Power Shuttle, 390 Hours",
    category: "Used",
    images: [
      "/Equipments/five/1.jpg",
      "/Equipments/five/2.jpg",
      "/Equipments/five/3.jpg",
      "/Equipments/five/4.jpg",
      "/Equipments/five/5.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "248-AGRO-MA-7193Q",
    name: "Used 2024 Takeuchi TB240 Mini Excavator",
    stockNumber: "248-AGRO-MA-7193Q",
    price: "60500",
    description:
      "Cab, A/C, WB Hydraulic Coupler, Backfill Blade, WB 12″, 24″, and 30″ Bucket, 66 Hours",
    category: "Used",
    images: [
      "/Equipments/seven/1.jpg",
      "/Equipments/seven/2.jpg",
      "/Equipments/seven/3.jpg",
      "/Equipments/seven/4.jpg",
      "/Equipments/seven/5.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "MA-661-9821-AGRO",
    name: "Used 2022 Case IH Farmall 75A Tractor",
    stockNumber: "MA-661-9821-AGRO",
    price: "46500",
    description:
      "Cab, A/C, 4X4, Loader, Engine 75HP, 60 PTO HP, 2 Rear Remotes, 12×12 Power Shuttle, 443 Hours",
    category: "Used",
    images: [
      "/Equipments/six/1.jpg",
      "/Equipments/six/2.jpg",
      "/Equipments/six/3.jpg",
      "/Equipments/six/4.jpg",
      "/Equipments/six/5.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "906-AGRO-MA-3317K",
    name: "Millcreek | Mid-Size Manure Spreader",
    stockNumber: "906-AGRO-MA-3317K",
    price: "7000",
    description:
      "Models 57 & 77 | Width 37″ To 44.5″ | Ground or PTO Drive | Horsepower 18 To 22 HP | For TractorsMillcreek | Mid-Size Manure Spreader",
    category: "New",
    images: [
      "/Equipments/eleven/1.webp",
      "/Equipments/eleven/2.webp",
      "/Equipments/eleven/3.webp",
      "/Equipments/eleven/4.webp",
      "/Equipments/eleven/5.webp",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },

  {
    id: "MA-517-3648-AGRO",
    name: "Used 2021 Massey Ferguson 1840 Square Baler",
    stockNumber: "MA-517-3648-AGRO",
    price: "22500",
    description: "Well kept square baler – field ready, N/A Hours",
    category: "Used",
    images: [
      "/Equipments/eight/1.jpg",
      "/Equipments/eight/2.jpg",
      "/Equipments/eight/3.jpg",
      "/Equipments/eight/4.jpg",
      "/Equipments/eight/5.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "AGRO-129-7741X-MA",
    name: "Used 2021 Kobelco SK17SR-6E",
    stockNumber: "AGRO-129-7741X-MA",
    price: "30500",
    description: "ROPS, 12″ Pin On Bucket, AUX HYD, 533 Hours",
    category: "Used",
    images: [
      "/Equipments/nine/1.jpg",
      "/Equipments/nine/2.jpg",
      "/Equipments/nine/3.jpg",
      "/Equipments/nine/4.jpg",
      "/Equipments/nine/5.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
  {
    id: "MA-845-2206-AGRO",
    name: "Used 2023 Deere 325G Compact Track Loader",
    stockNumber: "MA-845-2206-AGRO",
    price: "60500",
    description: "CAB, A/C, Standard AUX, 1069 Hours",
    category: "Used",
    images: [
      "/Equipments/ten/1.jpg",
      "/Equipments/ten/2.jpg",
      "/Equipments/ten/3.jpg",
    ],
    keyFeatures: [],
    specifications: [],
    shipping: {
      deliveryResponsibility:
        "Customers are responsible for ensuring delivery access for large trucks and equipment.",
      dockToDock:
        "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
      residentialShipping:
        "Residential shipping charges apply for deliveries to residential areas.",
      insideDelivery:
        "Inside delivery includes delivery to the Farm or Open Field close to the road and excludes rooms, suites, elevators, and stairs.",
      packingDisposal:
        "Customers are responsible for disposing of packing materials.",
    },
  },
];
